'use client';

import { c as _c } from "react/compiler-runtime";
import type { AppNavBarItem } from '@/components/footer/footer-nav-bar-menu-entries';
import { APP_NAV_BAR_ICONS, resolveAppNavBarEntries } from '@/components/footer/footer-nav-bar-menu-entries';
import { NavLink } from '@/components/footer/nav-link';
import type { Config } from '@/features/payload-cms/payload-types';
import { House } from 'lucide-react';
import { usePathname, useRouter } from 'next/navigation';
import React, { useMemo, useState, useTransition } from 'react';
export interface FooterAppNavBarProperties {
  locale: Config['locale'];
  items?: AppNavBarItem[] | undefined;
}
export const FooterAppNavBar: React.FC<FooterAppNavBarProperties> = t0 => {
  const $ = _c(21);
  const {
    locale,
    items
  } = t0;
  const pathname = usePathname();
  const router = useRouter();
  let t1;
  bb0: {
    if (items && items.length > 0) {
      t1 = items;
      break bb0;
    }
    let t2;
    if ($[0] !== locale) {
      t2 = resolveAppNavBarEntries(undefined, locale);
      $[0] = locale;
      $[1] = t2;
    } else {
      t2 = $[1];
    }
    t1 = t2;
  }
  const navItems = t1;
  let t2;
  let t3;
  if ($[2] !== navItems || $[3] !== pathname) {
    const pathnameWithoutLocale = pathname.replace(/^\/(de|en|fr)\/(.*)/, "/$2");
    t3 = navItems.reduce((accumulator, item) => {
      if (pathnameWithoutLocale.startsWith(item.href) && item.href.length > accumulator.length) {
        return item.href;
      }
      return accumulator;
    }, "");
    $[2] = navItems;
    $[3] = pathname;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  t2 = t3;
  const longestMatch = t2;
  const [isPending, startTransition] = useTransition();
  const [loadingHref, setLoadingHref] = useState();
  let t4;
  if ($[5] !== longestMatch || $[6] !== router) {
    t4 = href => {
      if (href === longestMatch) {
        return;
      }
      setLoadingHref(href);
      startTransition(() => {
        router.push(href);
      });
    };
    $[5] = longestMatch;
    $[6] = router;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const handleNavClick = t4;
  const currentLoadingHref = isPending ? loadingHref : undefined;
  let t5;
  if ($[8] !== currentLoadingHref || $[9] !== handleNavClick || $[10] !== isPending || $[11] !== longestMatch || $[12] !== navItems) {
    let t6;
    if ($[14] !== currentLoadingHref || $[15] !== handleNavClick || $[16] !== isPending || $[17] !== longestMatch) {
      t6 = item_0 => {
        const isActive = longestMatch === item_0.href || currentLoadingHref === item_0.href;
        const IconComponent = APP_NAV_BAR_ICONS[item_0.iconName] ?? House;
        return <NavLink key={`${item_0.href}-${item_0.label}`} href={item_0.href} icon={IconComponent} label={item_0.label} isActive={isActive} color={item_0.color} onClick={handleNavClick} isLoading={isPending} loadingHref={currentLoadingHref} />;
      };
      $[14] = currentLoadingHref;
      $[15] = handleNavClick;
      $[16] = isPending;
      $[17] = longestMatch;
      $[18] = t6;
    } else {
      t6 = $[18];
    }
    t5 = navItems.map(t6);
    $[8] = currentLoadingHref;
    $[9] = handleNavClick;
    $[10] = isPending;
    $[11] = longestMatch;
    $[12] = navItems;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[19] !== t5) {
    t6 = <div className="fixed bottom-0 left-(--app-content-left) z-40 flex h-20 w-[calc(100dvw-var(--app-content-left))] border-t-2 border-gray-200 bg-[#f8fafc]"><nav className="flex w-full items-center justify-around px-4">{t5}</nav></div>;
    $[19] = t5;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  return t6;
};